<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="primary mb-2 darken-2 card-r shadow-1 pl-3 text-white">
        <router-link to="/packages"><v-icon class="text-white pr-2 left">keyboard_arrow_left</v-icon></router-link>
        <div class="text-xs-left f-20">Edit : {{PackageTitle}}</div>
      </v-toolbar>
     <v-card class="card-r no-shadow">
              <v-form>
                <v-card-text>
                  <v-container grid-list-md class="pa-0">
                    <v-layout wrap >
                      <v-flex xs12 lg4><v-text-field outline :rules="requiredRule" v-model="PackageTitle" label="Package Title"></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg2>
                        <v-select
                          :items="types"
                          label="Package Price Type"
                          outline
                          v-model="CostType"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 lg3 v-if="CostType=='cost'">
                        <v-text-field outline v-model="PackagePrice" type="number" :rules="requiredRule" label="Package Price"></v-text-field></v-flex>
                      <v-flex xs12 lg3 v-if="CostType=='cost'">
                        <v-text-field outline v-model="InternalPrice" type="number" :rules="requiredRule" label="Internal Price"></v-text-field></v-flex>
                      <v-flex xs12 lg12 v-if="CostType=='cost'">
                        <v-combobox outline :items="modules" item-text="name" item-value="id" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select all classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                               v-text="data.item.name.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item.name }}</v-chip>
                          </template>
                        </v-combobox>
                      
                        <v-combobox outline :items="selectedClasses" item-text="name" item-value="id"  :rules="requiredRule"
                                    v-model="selectedFreeClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedFreeClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.name.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item.name }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>

                      
                      <v-flex xs12 lg12 v-if="CostType=='free'">
                        <v-combobox outline :items="modules" item-text="name"  item-value="id" @change="callMultiple" 
                                    v-model="FreePackageFreeClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedFreeClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.name.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item.name }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <!-- <v-flex xs12 lg12 v-if="CostType=='Custom'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->

                      <!-- <v-flex xs12 lg12 v-if="CostType=='Free Upto three classes'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select Classes by order" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 3'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select 3 Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->

                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 5'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select pay Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 5'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select 5 Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <v-flex xs12 lg12 >
                        <v-textarea outline v-model="Description"  name="input-7-1" label="Description"></v-textarea>
                      </v-flex>
                      <v-flex xs12 lg12 class="text-xs-center">
                          <v-progress-circular
                              indeterminate
                              v-if=loading
                              color="primary"
                          ></v-progress-circular>
                          <v-alert
                            :value="true"
                            color="success"
                            icon="check_circle"
                            v-if="alert.type=='success'"
                            outline
                          >
                            {{alert.msg}}
                          </v-alert>
                          <v-alert
                            :value="true"
                            color="error"
                            icon="warning"
                            v-if="alert.type=='warning'"
                            outline
                          >
                            {{alert.msg}}
                          </v-alert>
                      </v-flex>
                      <v-flex lg12 xs12 class="text-xs-right">
                        <!-- <ConfirmSignup v-on:confirmyes="updatePackage" v-bind:value1="PackageTitle" v-bind:value2="PackagePrice"/> -->
                        <ConfirmEdit v-on:confirmyes="packageEdit" v-bind:value1="PackageTitle" v-bind:value2="PackagePrice"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
    </v-card>
    </v-container>
</template>
<script>
  /* eslint-disable */
import ConfirmEdit from "../auth/ConfirmEdit";
import { mapState,dispatch } from 'vuex';
import { debug } from 'util';
import api from "../../utils/backend-api.js"
  export default {
    // name: "EditPackage",
    data: () => ({
      attachment: {
        photos: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      // PackageTitle:'',
      // PackagePrice:'',
      // InternalPrice:'',
      // Description:'',
      // selectedClasses:'',
      // module_id:[],
      // items: [],
      // items1: [
      //   'Three Wheeler',
      //   'motor Bike',
      //   'Car',
      // ],
      requiredRule: [v => !!v || "This field is required"],
      loading:false,
      alert:{
        type:"",
        msg:""
      },



      PackageTitle:'',
      types:['free','cost'],
      CostType:'',
      PackagePrice:'',
      InternalPrice:'',
      Description:'',
      FreePackageFreeClasses:[],
      selectedClasses:[],
      selectedFreeClasses:[],
      module_id:[],
      free_modules:[],
      items: [],
      items1:[],
    }),
    watch: {},
    created:function() {
        Store.commit('setLoading', { loading: true })
        Store.dispatch('Modules/getAllClasses')
        Store.commit('setLoading', { loading: false })
        setTimeout(() => {
            for(var i=0;i<this.modules.length;i++){
                // var id=this.modules[i].id
                var modules=this.modules[i]
                // var modu={
                //   id:this.modules[i].id,
                //   name:this.modules[i].name
                // }
                this.items.push(modules)
            }
        }, 1000)

        this.packId = this.$route.params.id;

        Store.dispatch("Packages/getPackageById", this.packId).then(res => {
        });
        let self=this
        setTimeout(() => {
            let cost=self.$store.state.Packages.adminpackages.cost
            let InternalPrice=self.$store.state.Packages.adminpackages.special_price
            
            self.CostType =self.$store.state.Packages.adminpackages.price_type;
            self.PackageTitle =self.$store.state.Packages.adminpackages.name;
            self.Description =self.$store.state.Packages.adminpackages.description;
            self.module_id =self.$store.state.Packages.adminpackages.modules;

            self.PackagePrice =cost.substring(0,cost.length-3)
            self.InternalPrice =InternalPrice.substring(0,InternalPrice.length-3)
            // self.selectedClasses=this.$store.state.Packages.adminpackages.modules;
            
            if(self.$store.state.Packages.adminpackages.price_type=='cost'){
              self.selectedClasses=this.$store.state.Packages.adminpackages.modules
              self.selectedFreeClasses=this.$store.state.Packages.adminpackages.free_modules_data
            }else if(self.$store.state.Packages.adminpackages.price_type=='free'){
              self.FreePackageFreeClasses=this.$store.state.Packages.adminpackages.modules
            }
        }, 3500);

    },
    methods: {
      packageEdit(){
        this.loading=true
        this.alert.type=""
        var moduleIdList=[]
          this.selectedClasses.forEach(function(element,index){
              moduleIdList.push(element.id)
          })
          console.log(moduleIdList)

          let selectedTotModulesId=[]
          let selectedFreeModulesId=[]
          let FreePackageFreeClassesId=[]
          this.selectedClasses.forEach(function(arr){
            selectedTotModulesId.push(arr.id)
          })
          this.selectedFreeClasses.forEach(function(arr){
            selectedFreeModulesId.push(arr.id)
          })
          this.FreePackageFreeClasses.forEach(function(arr){
            FreePackageFreeClassesId.push(arr.id)
          })
          var PackageDetails={
                'name':this.PackageTitle,
                'description':this.Description,
                'price_type':this.CostType,
                'special_price':this.InternalPrice,
                'cost':this.PackagePrice,
                'module_id':this.CostType=='free'?FreePackageFreeClassesId:selectedTotModulesId,
                'free_modules':this.CostType=='free'?FreePackageFreeClassesId:selectedFreeModulesId,
          }

          var packId=this.packId
          var Data={
            "PackageDetails":PackageDetails,
            "packId":this.packId
          }
          // this.$store.commit('setLoading', { loading: true })
          // this.$store.dispatch('Packages/packageEdit',Data).then(res=>{
          //   this.$store.commit('setLoading', { loading: false })

          // })
          api.postData('admin/package/' + Data.packId, Data.PackageDetails).then(res => {
            if(res.status==201){
                this.loading=false
                this.alert.type="success"
                this.alert.msg="Successfully Updated"
                setTimeout(() => {
                  this.$router.push("/packages");
                }, 800);
            }
          }).catch((error) => {
              this.loading=false
              this.alert.type="warning"
              this.alert.msg="Package Details updation failed"
          })
      },
      callMultiple(){
        // this.ModuleNameToId()
        this.packagePriceAutoCalculation()
      },
      ModuleNameToId() {
            this.module_id=[]
            var ModuleList=Store.state.Modules.modules
            var Names=this.selectedClasses
            for(var i=0;i<Names.length;i++){
              // console.lo
              for(var x=0;x<ModuleList.length;x++){

                if(Names[i]==ModuleList[x].id){
                    this.module_id.push(ModuleList[x].id)
                }
              }
            }
            console.log(module_id)
      },

      packagePriceAutoCalculation() {
            this.PackagePrice=''
            this.InternalPrice=''
            var ModuleList=Store.state.Modules.modules
            var Names=this.selectedClasses
            for(var i=0;i<Names.length;i++){
              for(var x=0;x<ModuleList.length;x++){


                if(Names[i].id==ModuleList[x].id){
                    this.PackagePrice=Number(this.PackagePrice)+Number(ModuleList[x].internal_price)
                    this.InternalPrice=Number(this.InternalPrice)+Number(ModuleList[x].internal_price)
                    console.log(ModuleList[x].internal_price)
                }
              }
            }

      },
      onPickImg(){
        this.$refs.ImgInput.click();
      },
      onImgPicked(){
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.attachment.photosURL.push(fileReader.result);

        });
        fileReader.readAsDataURL(files[0]);
        this.attachment.photos.push(files[0]);
      },

    },
    computed:{
      ...mapState ({
              packages:Packages => Store.state.Packages.packages,
              modules:Modules => Store.state.Modules.modules

      })
    },
    components: {
      ConfirmEdit
    }
  };
</script>
<style>
  .v-dialog{
    box-shadow: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/package/EditPackage.vue